import gql from "graphql-tag";

export const CREATE_UPDATE_VENDOR = gql`
mutation upsertVendor($vendor:[Vendors_insert_input!]!, $updateColumns: [Vendors_update_column!]!) {
  insert_Vendors(objects: $vendor, on_conflict: {constraint: Vendors_pkey, update_columns: $updateColumns}){
    returning{id}
  }
}`
